// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");

function msisdn(t) {
  return t.msisdn;
}

function email(t) {
  return t.email;
}

function survey_url(t) {
  return t.survey_url;
}

function status(t) {
  return t.status;
}

function decode(json) {
  return {
          msisdn: Json_decode.field("customer_detail", (function (param) {
                  return Json_decode.field("msisdn", Json_decode.string, param);
                }), json),
          email: Json_decode.field("customer_detail", (function (param) {
                  return Json_decode.field("email", Json_decode.string, param);
                }), json),
          survey_url: Json_decode.field("survey_url", Json_decode.string, json),
          status: Json_decode.field("status", Json_decode.string, json)
        };
}

var Transaction = {
  msisdn: msisdn,
  email: email,
  survey_url: survey_url,
  status: status,
  decode: decode
};

function fetchTransactions(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/campaigns/telephonic_transactions", (function (param) {
                return Json_decode.field("transactions", (function (param) {
                              return Json_decode.list(decode, param);
                            }), param);
              }));
}

function TelephonicSurveys(props) {
  var match = React.useState(function (param) {
        return "Loading";
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (transactions) {
                  return Promise.resolve(Curry._1(setState, (function (param) {
                                    return {
                                            TAG: "Available",
                                            _0: transactions
                                          };
                                  })));
                }), fetchTransactions());
        }), []);
  var bgStatusColor = function (status) {
    switch (status) {
      case "closed" :
          return "bg-firebrick";
      case "completed" :
          return "bg-americangreen";
      case "delivered" :
          return "bg-pigmentblue";
      case "open" :
          return "bg-candypink";
      case "responded" :
          return "bg-pelorous";
      default:
        return "hidden";
    }
  };
  var tmp;
  tmp = typeof state !== "object" ? JsxRuntime.jsx("p", {
          children: "Loading"
        }) : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("table", {
                children: [
                  JsxRuntime.jsx("thead", {
                        children: JsxRuntime.jsxs("tr", {
                              children: [
                                JsxRuntime.jsx("th", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              "Msisdn",
                                              JsxRuntime.jsx("img", {
                                                    className: "ml-4-px",
                                                    src: Image$ReactHooksTemplate.heading
                                                  })
                                            ],
                                            className: "flex"
                                          }),
                                      className: "px-4 py-2"
                                    }),
                                JsxRuntime.jsx("th", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              "Email",
                                              JsxRuntime.jsx("img", {
                                                    className: "ml-4-px",
                                                    src: Image$ReactHooksTemplate.heading
                                                  })
                                            ],
                                            className: "flex"
                                          }),
                                      className: "px-4 py-2"
                                    }),
                                JsxRuntime.jsx("th", {
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              "Status",
                                              JsxRuntime.jsx("img", {
                                                    className: "ml-4-px",
                                                    src: Image$ReactHooksTemplate.heading
                                                  })
                                            ],
                                            className: "flex"
                                          }),
                                      className: "px-4 py-2"
                                    }),
                                JsxRuntime.jsx("th", {
                                      children: JsxRuntime.jsx("div", {
                                            children: "",
                                            className: "flex"
                                          }),
                                      className: "px-4 py-2"
                                    })
                              ]
                            }),
                        className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                      }),
                  JsxRuntime.jsx("tbody", {
                        children: $$Array.of_list(List.map((function (x) {
                                    return JsxRuntime.jsxs("tr", {
                                                children: [
                                                  JsxRuntime.jsx("td", {
                                                        children: x.msisdn,
                                                        className: "px-4 py-2"
                                                      }),
                                                  JsxRuntime.jsx("td", {
                                                        children: x.email,
                                                        className: "px-4 py-2"
                                                      }),
                                                  JsxRuntime.jsx("td", {
                                                        children: JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx("div", {
                                                                      className: "h-3 w-3 rounded-full " + bgStatusColor(x.status)
                                                                    }),
                                                                x.status.toUpperCase()
                                                              ],
                                                              className: "text-10-px px-2 py-1 rounded-2xl flex gap-1 items-center\n                                    border border-gray-400 w-fit font-normal text-aurometalsaurus"
                                                            }),
                                                        className: "px-4 py-2"
                                                      }),
                                                  JsxRuntime.jsx("td", {
                                                        children: x.status !== "completed" ? JsxRuntime.jsx("button", {
                                                                children: "Take Survey",
                                                                className: "bg-ghostwhite border border-gray-400\n                                     shadow-inner flex rounded py-2 px-3 text-xs\n                                     hover:bg-pigmentblue hover:text-white",
                                                                onClick: (function (param) {
                                                                    var newWindow = window.open(x.survey_url, "Name", "sfs");
                                                                    if (!(newWindow == null)) {
                                                                      newWindow.addEventListener("drop", (function (param) {
                                                                              Curry._1(setState, (function (param) {
                                                                                      return "Loading";
                                                                                    }));
                                                                            }));
                                                                      return ;
                                                                    }
                                                                    
                                                                  })
                                                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                                        className: "px-4 py-2"
                                                      })
                                                ],
                                                className: "border-b border-bottom-gray-600"
                                              });
                                  }), state._0))
                      })
                ],
                className: "text-left table-auto w-full border-separate text-xs font-medium"
              }),
          className: "flex px-30-px pb-30-px"
        });
  return JsxRuntime.jsx("div", {
              children: tmp,
              className: "m-30-px"
            });
}

var make = TelephonicSurveys;

exports.Transaction = Transaction;
exports.fetchTransactions = fetchTransactions;
exports.make = make;
/* react Not a pure module */
